import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useToast } from "../components/Toast";
import { api } from "./api";

/** "New work": creates an untitled draft and opens it. Shared by the Works list and the ⌘K menu. */
export function useCreateWork() {
  const navigate = useNavigate();
  const toast = useToast();
  return useMutation({
    mutationFn: () => api<{ id: string }>("/studio/works", { method: "POST", json: { title: "Untitled work" } }),
    onSuccess: ({ id }) => void navigate({ to: "/works/$id", params: { id } }),
    onError: (e) => toast(e.message, "error"),
  });
}
